// 系统内置分类配置
export const SYSTEM_CATEGORIES = {
  PRODUCT_KNOWLEDGE: {
    id: 1,
    name: '产品知识库',
    code: 'product-knowledge',
    description: '产品功能、特性、规格等详细介绍',
    icon: 'el-icon-box',
    color: '#409EFF'
  },
  OPERATION_GUIDE: {
    id: 2,
    name: '操作指南',
    code: 'operation-guide',
    description: '产品使用教程、操作步骤说明',
    icon: 'el-icon-notebook-2',
    color: '#67C23A'
  },
  TROUBLESHOOTING: {
    id: 3,
    name: '故障排查',
    code: 'troubleshooting',
    description: '常见问题解决方案、错误代码说明',
    icon: 'el-icon-warning',
    color: '#E6A23C'
  },
  POLICY_DOCUMENT: {
    id: 4,
    name: '政策文档',
    code: 'policy-document',
    description: '服务条款、隐私政策、合规文档',
    icon: 'el-icon-document',
    color: '#909399'
  },
  TRAINING_MATERIAL: {
    id: 5,
    name: '培训资料',
    code: 'training-material',
    description: '客服培训材料、话术模板',
    icon: 'el-icon-reading',
    color: '#F56C6C'
  }
}

// 获取所有系统分类
export const getAllSystemCategories = () => {
  return Object.values(SYSTEM_CATEGORIES)
}

// 根据代码获取分类
export const getCategoryByCode = (code) => {
  return Object.values(SYSTEM_CATEGORIES).find(cat => cat.code === code)
}
